import React, { useContext, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { AuthContext } from "../contexts/AuthContext";
import { useEffect } from "react";
import {  useNavigate } from "react-router-dom";
import { FiShoppingCart } from "react-icons/fi";
import { AiFillHeart } from "react-icons/ai";
import axios from "axios";
import { ProductContext } from "../contexts/ProductContext";

function UserProfile() {
  const { isAuthenticated, userData, setUserData } = useContext(AuthContext);
  const { setCartOpen, setIsWishlistOpen } =
    useContext(ProductContext);
    // const usersBaseURL = process.env.USER_API_URL;
    // const ordersBaseURL = process.env.ORDER_API_URL;
  
    // console.log(usersBaseURL,ordersBaseURL)
  // const [myOrderLength, setMyOrderLength] = useState(0);
  const [myOrders, setMyOrders] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated,navigate]);

  // const [wishlistItems] = useState(
  //   JSON.parse(localStorage.getItem("wishlistItems")) || []
  // );
  // useEffect(() => {
  //   // This will log the updated userData whenever it changes
  //   if (isAuthenticated) {
  //     setMyOrderLength(userData.myOrders.length)
  //   }else{
  //     setMyOrderLength(0)
  //   }

  // }, [userData]); // Make sure to include userData in the dependency array

  useEffect(() => {
    if (isAuthenticated) {
      fetchMyOrders(userData.id);
    }
  }, []);

  const fetchMyOrders = async (userId) => {
    try {
      // const response = await axios.get(`http://localhost:3001/users/${userId}`);
      const response = await axios.get(`https://ecommerce-user-api.onrender.com/users/${userId}`);
      // const response = await axios.get(`${usersBaseURL}/${userId}`);
      const user = response.data;
      // console.log(user);
      // // Check if userData has changed, and if not, return early
      // if (JSON.stringify(user) === JSON.stringify(userData)) {
      //   return;
      // }

      setUserData(user);

      if (user.myOrders && user.myOrders.length > 0) {
        // Fetch details of each order
        const ordersData = await Promise.all(
          user.myOrders.map((order) => fetchOrderDetails(order))
        );
        setMyOrders(ordersData);
        // console.log(ordersData[0]);
      } else {
        setMyOrders([]);
      }
    } catch (error) {
      console.error("Error fetching user orders:", error);
    }
  };

  const fetchOrderDetails = async (order) => {
    try {
      // console.log(order);
      // const response = await axios.get(`http://localhost:3001/orders/${order}`);
      const response = await axios.get(`https://ecommerce-user-api.onrender.com/orders/${order}`);
      // const response = await axios.get(`${ordersBaseURL}/${order}`);
      // Log the response data
      return response.data;
    } catch (error) {
      console.error("Error fetching order details:", error);
      return null;
    }
  };

  const navigateToDetails = (product) => {
    const extractedId = product.id.substring(product.id.lastIndexOf("/") + 1);

    navigate(`/products/${extractedId}`);
  }


  return (
    <div>
      <Navbar />
      {isAuthenticated && (
        <div className="container">
          <div className="flex justify-center items-start gap-2 p-4 border-b font-primaryFont image-container">
            <div className="profile-pic">
              <img src={userData.profilePic} alt="" />
            </div>

            <div className="flex flex-col justify-center items-start gap-2 detail-container">
              <h1>
                <b>Name:</b> {userData.name}
              </h1>
              <h3>
                <b>Email:</b> {userData.email}
              </h3>
              <div className="flex justify-center items-center gap-2 btn-container">
                <button
                  onClick={() => setCartOpen(true)}
                  className="flex justify-center items-center gap-2 bg-black hover:bg-primary p-2 rounded-md font-primaryFont font-semibold text-[12px] text-white tracking-wider"
                >
                  MY CART <FiShoppingCart />
                </button>

                <button
                  onClick={() => setIsWishlistOpen(true)}
                  className="flex justify-center items-center gap-2 bg-black hover:bg-primary p-2 rounded-md font-primaryFont font-semibold text-[12px] text-white tracking-wider"
                >
                  MY WISHLIST <AiFillHeart />
                </button>
              </div>
            </div>
          </div>
          <div className="myorder-container pt-2 container">
            <h2 className="p-2 border-b font-bold font-secondaryFont text-center">
              MY ORDERS
            </h2>
            <div className="cart-item-container overflow-y-scroll">
              <div className="p-4 cart-card-container">
                {myOrders.map((order) => {
                  return order.productsData.map((product, index) => {
                    return (
                      <div
                        key={product.id} onClick={() => navigateToDetails(product)}
                        className="flex justify-between items-start gap-2 py-2 border-b w-full cursor-pointer cart-card"
                      >
                        <div className="p-2 w-[25%] image-container">
                          <img src={product.image} alt={product.title} />
                        </div>
                        <div className="relative flex flex-col justify-start items-start space-y-2 pt-2 w-[70%] font-primaryFont text-sm detail-container">
                          <h2 className="mb-1 tracking-wider">
                            {product.title}
                            {/* {product.title.split(" - ")[0]} */}
                          </h2>
                          {/* <p className="text-xs">
                      <span className="font-semibold">Color:</span>{" "}
                      {
                        product.options.find(
                          (option) => option.name === "Color"
                        ).values[0]
                      }
                    </p> */}
                          <p className="text-xs">
                            <span className="font-semibold">Size :</span>{" "}
                            {product.Size}
                          </p>
                          <p className="text-xs">
                            <span className="font-semibold">Quantity :</span>{" "}
                            {product.quantity}
                          </p>
                          <p className="text-xs">
                            <span className="font-semibold">Status :</span>{" "}
                            {order.status}
                          </p>
                          <p className="text-xs">
                            <span className="font-semibold">
                              payment Method :
                            </span>{" "}
                            {order.paymentMethod}
                          </p>
                          <div className="relative flex justify-between items-center w-full quantity-total-container">
                            <div className="w-full font-primaryFont total-container">
                              <p className="font-semibold text-xs capitalize tracking-widest">
                                Total : {product.totalPrice}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  });
                })}
                {userData.myOrders.length <= 0 && (
                  <p className="font-bold text-center text-red-500 tracking-wider">
                    No Orders{" "}
                    <span className="text-blue-500 underline">
                      Please Make Order
                    </span>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default UserProfile;
